import { Modal } from "flowbite-react";
import { Formik } from "formik";
import { updateForecastMaintenance } from "../../../../../common/services/maintenance.api";
import { useToastContext } from "../../../../../common/components/ui/toast/toast.context";
import * as Yup from "yup";
import InputFormik from "../../../../../common/components/form/InputFormik";
import ButtonWithLoader from "../../../../../common/components/ui/loading/ButtonLoading";

type Props = {
  data: {
    dateNextMaintenance: Date;
    odometer: number;
  };
  maintenanceId: string;
  onClose: () => void;
  setHasUpdated: (boolean) => void;
};

const validationSchema = Yup.object().shape({
  dateNextMaintenance: Yup.date().required(),
  odometer: Yup.number().required(),
});

const formatDate = (isoDate) => {
  new Date(isoDate);
  return isoDate.split("T")[0];
};

function ModalForecastMaintenanceEdit({
  data,
  maintenanceId,
  onClose,
  setHasUpdated,
}: Props) {
  const { notifySuccess, notifyError } = useToastContext();

  const initialValues = {
    dateNextMaintenance: formatDate(data.dateNextMaintenance),
    odometer: data.odometer,
  };

  const handleSubmit = async (values) => {
    const { ok } = await updateForecastMaintenance({
      maintenanceId,
      forecastMaintenance: {
        dateNextMaintenance: new Date(values.dateNextMaintenance),
        odometer: values.odometer,
      },
    });
    if (ok) {
      setHasUpdated(true);
      notifySuccess("Atualizado com sucesso");
      handleCloseModal();
    } else {
      notifyError("Não foi possível atualizar");
    }
  };

  const handleCloseModal = () => {
    onClose();
  };

  return (
    <Modal
      size="4xl"
      className="absolute"
      show={true}
      onClose={handleCloseModal}
    >
      <Modal.Header className="text-black">
        <div className="flex items-center justify-start gap-3">
          <span className="text-black">Editando Previsão de Manutenção</span>
        </div>
      </Modal.Header>

      <Modal.Body
        className="relative border-gray gap gap-3 flex flex-col dark:text-black"
        style={{
          minHeight: "calc(100vh - 650px)",
          height: "calc(100vh - 300px)",
        }}
      >
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          {({ isSubmitting, handleSubmit, errors }) => {
            return (
              <>
                <label className="text-black text-lg font-normal">
                  Data Próxima Manutenção
                </label>
                <InputFormik
                  name="dateNextMaintenance"
                  type="date"
                ></InputFormik>
                <label className="text-black text-lg font-normal">
                  Hodômetro
                </label>
                <InputFormik
                  name="odometer"
                  type="number"
                  className="mb-3"
                ></InputFormik>
                <ButtonWithLoader
                  disabled={Object.values(errors).length ? true : false}
                  type="button"
                  isLoading={isSubmitting}
                  onClick={handleSubmit}
                >
                  Enviar
                </ButtonWithLoader>
              </>
            );
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}

export default ModalForecastMaintenanceEdit;
